import { ActionBase } from '../../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../../datawarehouse.module.config';
import { SaveResultsModel } from '../../models/SaveResultsModel';

export const REVISE_ROOT_ENTITY_RESPONSE = `[${ModuleConfiguration.moduleName}] Revise Root Entity Response`;

export class ReviseRootEntityResponseAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = REVISE_ROOT_ENTITY_RESPONSE;

  constructor(public payload: { entityKey: string, key: string, model: any, scope: string, results: SaveResultsModel }) {}
}


// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/ReviseRootEntityResponseAction.ts